module.exports = __webpack_public_path__ + "static/media/manda-1.e39da8fb.jpg";